import { PatientGroupAssignment } from '@dreryk/egabinet-patient-frontend-api';

import { PatientGroupsAssignmentsFormBean } from './PatientGroupsAssignmentsForm.types';

export const patientGroupsAssignmentsFormInitializer = (
   assignedPatientGroups: PatientGroupAssignment[]
) => (): PatientGroupsAssignmentsFormBean => ({
   patientGroups: assignedPatientGroups.map(({ patientGroup }) => ({
      effects: [],
      possibleEffects: [],
      id: patientGroup.id,
      name: patientGroup.name,
      primaryColor: patientGroup.primaryColor,
      darkModeColor: patientGroup.darkModeColor,
      active: false,
      predefined: true,
   })),
});
